import { Badge, Button, Form } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import { AiOutlineEdit } from "react-icons/ai";

const FormFields = ({ field, setFields, setOpenCustomization }) => {
  const deleteField = (id) => {
    setFields((prev) => prev.filter((f) => f.id !== id));
  };
  let Icon = field?.icon
  return (
    <div className="border bg-light rounded-1 p-3 mb-3 position-relative">
      <Form.Group>
        <div className="hstack justify-content-between mb-2">
          <Form.Label className="fw-bold mb-0" style={{ fontSize: 13 }}>
            {field?.label} <span className="text-danger">*</span>
          </Form.Label>

          <div className="d-flex gap-2">
            <Button
              variant="outline-primary"
              className="hstack gap-2 text-nowrap rounded-1"
              style={{ fontSize: 10 }}
              onClick={() => setOpenCustomization(true)}
            >
              <AiOutlineEdit />
            </Button>
            <Button
              variant="outline-danger"
              className="hstack gap-2 text-nowrap rounded-1"
              style={{ fontSize: 10 }}
              onClick={() => deleteField(field?.id)}
            >
              <FaTrashAlt />
            </Button>
          </div>
        </div>

        {field?.type === "radio" && (
          <>
            <Form.Check type="radio" name="redio" label="Option 1" style={{ fontSize: 12 }} />
            <Form.Check type="radio" name="redio" label="Option 2" style={{ fontSize: 12 }} />
          </>
        )}

        {field?.type === "checkbox" && (
          <>
            <Form.Check type="checkbox" label="Option 1" style={{ fontSize: 12 }} />
            <Form.Check type="checkbox" label="Option 2" style={{ fontSize: 12 }} />
          </>
        )}

        {field?.type === "range" && <Form.Range />}

        {field?.type === "textarea" && (
          <Form.Control
            as={`textarea`}
            rows={3}
            placeholder={`Enter Description`}
            style={{ fontSize: 12 }}
          />
        )}

        {field?.type === "button" && (
          <Button className="icon-btn w-100">Button</Button>
        )}

        {!["radio", "checkbox", "button", "textarea", "range"].includes(field?.type) && (
          <Form.Control
            type={field?.type}
            placeholder={`Enter ${field?.label}`}
            style={{ fontSize: 12 }}
          />
        )}
      </Form.Group>

      <Badge
        className="position-absolute top-0 start-0 rounded-1 translate-middle-y ms-2"
        style={{ width: 80 }}
      >
        <Icon className="me-1" /> {field?.label}
      </Badge>
    </div>
  );
};

export default FormFields;
